import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
    isErrorR:false,
    messageR:'',
    isLoadingR:false,
    isSuccessR:false
}




// Get User userData
export const ResetPasswordFunction = createAsyncThunk('ResetPassword/sendEmail', async(ResetData, thunkAPI)=>{

    try{
        const API_URL = `${process.env.REACT_APP_SERVER_URL}/api/users/reset-password`
        // const API_URL = 'http://localhost:5000/api/users/reset-password'
        const response = await axios.put(API_URL, ResetData)
        console.log(response.data)
        return response.data
 
    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        return thunkAPI.rejectWithValue(message)
    }
})





export const ResetPasswordSlice = createSlice({
    name:'ResetPassword',
    initialState,
    reducers:{
        reset: (state)=> initialState,
    },
    extraReducers:(builder)=>{
        builder
        .addCase(ResetPasswordFunction.pending, (state, action)=>{
            state. isLoadingR = true
        })
        .addCase(ResetPasswordFunction.fulfilled, (state, action)=>{
            state.messageR = action.payload.message
            state. isLoadingR = false
            state. isSuccessR = true
        })
        .addCase(ResetPasswordFunction.rejected, (state, action)=>{
            state.isErrorR = true
            state.messageR = action.payload
        })

    }
})


export const {reset} = ResetPasswordSlice.actions
export default ResetPasswordSlice.reducer